var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"events-partners"},_vm._l((_vm.content.categories),function(category,index){return _c('members-grid',{key:("members-grid-category-" + index),attrs:{"content":{
      title: category.title,
      items: category.partners,
    }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }